import { useQuery } from '@apollo/client/react';
import React, { useEffect, useMemo, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { MultiSelectDropdownV2 } from '../../_common/MultiSelectDropdown/MultiSelectDropdownV2';
// import { ValueType } from 'react-select/src/types';
import {
    GET_USERS_CHECK_EMAIL,
    GET_USERAUDIT,
    GET_ALL_REGIONS,
    GET_USER_REGION_DISTRICT_BY_USER_ID,
} from '../../../graphql/client/queries';
import {
    GetUsersCheckEmail,
    GetUsers_getUsers as User,
    GetUserRegionDistrictByUserId as UserRegionDistrict,
    GetUsersAudit,
    GetUsersAudit_getUsersAudit as UserAuditType,
    GetAllRegions,
    GetAllRegions_getAllRegions as RegionType,
    GetAllRegions_getAllRegions_districts as DistrictType,
} from '../../../types/schemaTypes';
import { CustomButton } from '../../_common';
import SearchableDropdown from '../../_common/SearchableDropdown/SearchableDropdown';
import { Textfield } from '../../_common/Textfield/Textfield';
import { ModalForm } from '../interface';
import './AddEditUserModal.scss';
import moment from 'moment';

interface Option {
    id: number | string;
    name: string | number;
}
interface OptionType {
    label: string;
    value: string;
}
interface UserAudits {
    id: number;
    userId: number | null;
    auditDate: string | null;
    auditUserName: string | null;
    nameBefore: string | null | undefined;
    emailAddressBefore: string | null | undefined;
    isActiveBefore: boolean | null | undefined;
    roleIdBefore: number | null | undefined;
    nameAfter: string | null | undefined;
    emailAddressAfter: string | null | undefined;
    isActiveAfter: boolean | null | undefined;
    roleIdAfter: number | null | undefined;
}
// interface UserData {
//     name: string | null;
//     emailAddress: string | null;
//     isActive: boolean | null;
//     isDeleted: boolean | null;
//     roleId: number | null;
// }
interface AddEditUserModalProps {
    modalForm: ModalForm;
    options: Option[];
    selectedUser?: User;
    onClickHide: () => void;
    onClickSave: (
        id: number,
        name: string,
        email: string,
        roleId: number,
        status: boolean,
        regionIds: string,
        districtIds: string,
    ) => void;
    show: boolean;
    errorMessage?: string;
    userId: number;
}

const AddEditUserModal = ({
    show,
    options,
    onClickHide,
    onClickSave,
    modalForm,
    selectedUser,
    errorMessage,
    userId,
}: AddEditUserModalProps): React.ReactElement => {
    const { data: regionsData } = useQuery<GetAllRegions>(GET_ALL_REGIONS);
    const regions: OptionType[] = [];
    const initialDistrictsnew: OptionType[] = [];
    const initialSelectedRegions: OptionType[] = [];
    const initialSelectedDistricts: OptionType[] = [];
    const [selectedId, setSelectedId] = useState(0);
    const [selectedName, setSelectedName] = useState('');
    const [selectedEmail, setSelectedEmail] = useState('');

    const [userRegionIds, setUserRegionIds] = useState('');
    const [userDistrictIds, setUserDistrictIds] = useState('');

    const [selectedRole, setSelectedRole] = useState(0);
    const [selectedStatus, setSelectedStatus] = useState(true);

    const [selectedRegionIds, setSelectedRegionIds] = useState('');
    const [selectedDistrictIds, setSelectedDistrictIds] = useState('');

    const [selectedDistricts, setSelectedDistricts] = useState(initialSelectedDistricts);
    const [selectedRegions, setSelectedRegions] = useState(initialSelectedRegions);
    const [availableDistricts, setAvailableDistricts] = useState(initialDistrictsnew);

    const isEditForm = modalForm === ModalForm.EDIT_USER;

    const [emailExists, setEmailExists] = useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = useState('');

    const { data: userRegionDistrict } = useQuery<UserRegionDistrict>(GET_USER_REGION_DISTRICT_BY_USER_ID, {
        variables: { userId: selectedId },
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        setSelectedDistricts(initialSelectedDistricts);
        setSelectedRegions(initialSelectedRegions);

        if (
            userRegionDistrict &&
            userRegionDistrict.getUserRegionDistrictByUserId &&
            userRegionDistrict.getUserRegionDistrictByUserId.districtIds !== ''
        ) {
            setUserDistrictIds(userRegionDistrict.getUserRegionDistrictByUserId.districtIds);
            setSelectedDistrictIds(userRegionDistrict.getUserRegionDistrictByUserId.districtIds);
        } else {
            setUserDistrictIds('');
        }
        if (
            userRegionDistrict &&
            userRegionDistrict.getUserRegionDistrictByUserId &&
            userRegionDistrict.getUserRegionDistrictByUserId.regionIds !== ''
        ) {
            setUserRegionIds(userRegionDistrict.getUserRegionDistrictByUserId.regionIds);
            setSelectedRegionIds(userRegionDistrict.getUserRegionDistrictByUserId.regionIds);
        } else {
            setUserRegionIds('');
            setSelectedRegionIds('');
        }
        // setUserRegionIds(userRegionDistrict.getUserRegionDistrictByUserId?.regionIds?'');
        // setUserDistrictIds(userRegionDistrict?.getUserRegionDistrictByUserId?.districtIds);
        if (selectedUser) {
            setSelectedId(selectedUser.id ? selectedUser.id : 0);

            setSelectedName(selectedUser.name ? selectedUser.name : ' ');
            setSelectedEmail(selectedUser.emailAddress ? selectedUser.emailAddress : ' ');
            setSelectedRole(selectedUser.roleId ? selectedUser.roleId : 0);
            setSelectedStatus(selectedUser.isActive ? true : false);

            if (userRegionIds !== '') {
                const regionlist = userRegionIds.split(',');
                const tmpRegions: OptionType[] = [];
                const tmpDistricts: OptionType[] = [];
                for (let i = 0; i < regionlist.length; i++) {
                    if (regions.find(l => l.value === regionlist[i]))
                        var tmpRegion = regions.find(l => l.value === regionlist[i]);

                    if (tmpRegion && tmpRegion.label !== null)
                        tmpRegions.push({
                            value: regionlist[i],
                            label: tmpRegion.label,
                        });

                    regionsData?.getAllRegions?.forEach((element) => {
                        if (!element || parseInt(regionlist[i]) !== element.id || !element.districts) return;
                            if (userDistrictIds !== '') {
                                const districtlist = userDistrictIds.split(',');
                                for (let d = 0; d < districtlist.length; d++) {
                                    const tmpDistrict = element.districts.find(
                                        ed => ed?.id === parseInt(districtlist[d]),
                                    );
                                    if (tmpDistrict?.districtName)
                                        tmpDistricts.push({
                                            value: districtlist[d],
                                            label: tmpDistrict.districtName,
                                        });
                                }
                            }
                    });
                }
                setSelectedRegions(tmpRegions);
                setSelectedDistricts(tmpDistricts);
            } else {
                setSelectedRegions(initialSelectedRegions);
                setSelectedDistricts(initialSelectedDistricts);
            }
        }
        if (!isEditForm) {
            setSelectedRegionIds('');
        }
    }, [selectedUser, userRegionDistrict, userRegionIds, userDistrictIds]);

    const { data: checkEmailData } = useQuery<GetUsersCheckEmail>(GET_USERS_CHECK_EMAIL, {
        variables: { input: { emailAddress: selectedEmail } },
        fetchPolicy: 'no-cache',
    });

    useEffect(() => {
        if (!checkEmailData?.getUsersCheckEmail) return;
        const emailExistsVal =
            checkEmailData.getUsersCheckEmail.emailExists == null ? false : checkEmailData.getUsersCheckEmail.emailExists;
        const checkEmailExists =
            (isEditForm && selectedEmail === selectedUser?.emailAddress) || selectedEmail.length === 0
                ? false
                : emailExistsVal;
        setEmailExists(checkEmailExists);
        setEmailErrorMessage(checkEmailExists ? 'This email address is already in use' : '');
    }, [checkEmailData, isEditForm, selectedEmail, selectedUser?.emailAddress]);

    const variables = {
        userId,
    };

    const { data: userAuditReferenceData } = useQuery<GetUsersAudit>(GET_USERAUDIT, { variables });

    const userAuditHistory: UserAudits[] = useMemo(() => {
        const list: UserAudits[] = [];
        userAuditReferenceData?.getUsersAudit?.forEach((element) => {
            if (!element || element.userId == null) return;
            list.push({
                id: element.id ?? 0,
                userId: element.userId ?? null,
                auditUserName: element.auditUserName ?? null,
                auditDate: element.auditDate ?? null,
                nameBefore: element.valuesBefore?.name,
                nameAfter: element.valuesAfter?.name,
                isActiveBefore: element.valuesBefore?.isActive,
                isActiveAfter: element.valuesAfter?.isActive,
                emailAddressBefore: element.valuesBefore?.emailAddress,
                emailAddressAfter: element.valuesAfter?.emailAddress,
                roleIdBefore: element.valuesBefore?.roleId,
                roleIdAfter: element.valuesAfter?.roleId,
            });
        });
        return list;
    }, [userAuditReferenceData]);

    const clearState = (): void => {
        setSelectedId(0);
        setSelectedName('');
        setSelectedEmail('');

        setUserRegionIds('');
        setUserDistrictIds('');

        setSelectedRole(0);
        setSelectedStatus(true);

        setSelectedRegionIds('');
        setSelectedDistrictIds('');

        setSelectedDistricts(initialSelectedDistricts);
        setSelectedRegions(initialSelectedRegions);
        setAvailableDistricts(initialDistrictsnew);

        setEmailExists(false);
        setEmailErrorMessage('');
    };

    const onSave = (): void => {
        if (!emailExists) {
            onClickSave(
                selectedId,
                selectedName,
                selectedEmail,
                selectedRole,
                selectedStatus,
                selectedRegionIds,
                selectedDistrictIds,
            );
            clearState();
        }
    };

    const onCancel = (): void => {
        clearState();
        onClickHide();
    };

    const validateEmail = (email: string): boolean => {
        const emailRegex = /\S+@(ussilica|sandboxlogistics)\.\S+/;
        const isEmailValid = emailRegex.test(email.toString());

        return isEmailValid;
    };

    const setSaveButtonStatus = (): boolean => {
        const isNameValid = selectedName.trim().length > 2 ? true : false;
        const isEmailValid = validateEmail(selectedEmail);
        let isRegionValid = true;

        const selectedRoleName = options.find(option => option.id === selectedRole)?.name.toString() ?? '';
        if (['Forklift Operator', 'Lead Manager', 'Lead Operator'].includes(selectedRoleName))
            isRegionValid = selectedRegionIds?.length > 0 ? true : false;
        const isRoleValid = selectedRole != 0 ? true : false;
        const isStatusValid = true;

        const isFormValid = isNameValid && isEmailValid && isRegionValid && isRoleValid && isStatusValid;

        if (emailExists) return true;

        return !isFormValid;
    };

    const changeName = (event: any): void => {
        setSelectedName(event.target.value);
    };

    const changeEmail = (value: any): void => {
        const emailAddress = value ? value : '';

        setSelectedEmail(emailAddress.trim());
    };

    const getRoleName = (): string | number | null => {
        const id = selectedUser && selectedUser.roleId ? selectedUser.roleId.toString() : '';

        if (id == '') return null;

        const numId = parseInt(id);
        
        const filteredRole = options.filter((item: Option) => item.id === numId);
        const role = filteredRole[0].name;

        return role;
    };
    const getAuditRoleName = (roleId: number): string | number | null => {
        const filteredRole = options.filter((item: Option) => item.id === roleId);
        const role = filteredRole[0].name;

        return role;
    };

    const changeRole = (value: any): void => {
        const id = parseInt(value);
        setSelectedRole(id);
    };

    const changeStatus = (event: any): void => {
        const boolValue = JSON.parse(event.target.value);

        setSelectedStatus(boolValue);
    };
    if (regionsData && regionsData.getAllRegions) {
        regionsData.getAllRegions.forEach((element: RegionType | null) => {
            if (!element || element.regionName === null) return;
            regions.push({ value: element.id.toString(), label: element.regionName });
        });

        if (
            userRegionDistrict &&
            userRegionDistrict.getUserRegionDistrictByUserId &&
            userRegionDistrict.getUserRegionDistrictByUserId.districtIds !== ''
        ) {
            const regionIds = userRegionDistrict.getUserRegionDistrictByUserId.districtIds.split(',');

            const districtsListNew: OptionType[] = [];

            regionsData.getAllRegions.forEach((element: RegionType | null) => {
                if (!element || !regionIds.find(x => parseInt(x) === element.id) || !element.districts) return;
                element.districts.forEach((element1: DistrictType | null) => {
                    if (element1?.districtName != null) {
                        districtsListNew.push({
                            value: element1.id.toString(),
                            label: element1.districtName,
                        });
                    }
                });
            });
        }
    }
    const getAvailableDistricts = (regionId: number[]): void => {
        const districtsListNew: OptionType[] = [];
        const currentSelectedDistricts: OptionType[] = [];

        setAvailableDistricts(districtsListNew);
        regionsData?.getAllRegions?.forEach((element: RegionType | null) => {
            if (!element || !regionId.find(x => x === element.id) || !element.districts) return;
            element.districts.forEach((element1: DistrictType | null) => {
                if (element1?.districtName != null) {
                    districtsListNew.push({
                        value: element1.id.toString(),
                        label: element1.districtName,
                    });
                }
            });
        });
        setAvailableDistricts(districtsListNew);

        if (selectedDistricts && selectedDistricts !== null && Array.isArray(selectedDistricts)) {
            for (let i = 0; i < selectedDistricts.length; i++) {
                if (selectedDistricts[i] && selectedDistricts[i].value !== null) {
                    var tmp = selectedDistricts[i].value;
                    if (districtsListNew.find(x => x.value === tmp)) {
                        currentSelectedDistricts.push(selectedDistricts[i]);
                    }
                }
            }
        }
        setSelectedDistricts(currentSelectedDistricts);
    };
    const onRegionChange = (selectedRegion: OptionType): void => {
        const regionIds: number[] = [];
        if (selectedRegion && selectedRegion !== null && Array.isArray(selectedRegion)) {
            for (let i = 0; i < selectedRegion.length; i++) {
                regionIds.push(parseInt(selectedRegion[i].value));
            }

            setSelectedRegions(selectedRegion);
        }
        getAvailableDistricts(regionIds);
        setSelectedRegionIds(regionIds.toString());
    };
    const onDistrictChange = (selectedDistrict: OptionType): void => {
        const districtIds: number[] = [];
        if (selectedDistrict && selectedDistrict !== null && Array.isArray(selectedDistrict)) {
            setSelectedDistricts(selectedDistrict);
            for (let i = 0; i < selectedDistrict.length; i++) {
                districtIds.push(parseInt(selectedDistrict[i].value));
            }
        }
        setSelectedDistrictIds(districtIds.toString());
    };
    return (
        <Modal show={show} onHide={onCancel} size="lg">
            <Modal.Header className="AddEditUserModal-Header">
                <Modal.Title className="AddEditUserModal-Header-Container">
                    <button className="material-icons AddEditUserModal-X-Button" onClick={onCancel}>
                        close
                    </button>
                    <div className="AddEditUserModal-Title">{isEditForm ? 'Edit User' : 'Create New User'}</div>
                    <div className="AddEditUserModal-ErrorMessage">{errorMessage}</div>
                </Modal.Title>
            </Modal.Header>
            <div className="AddEditUserModal-Upper-TextField-Container">
                <div className="AddEditUserModal-Textfield">
                    <Textfield
                        label="Name"
                        value={selectedUser !== undefined ? selectedUser.name : ''}
                        onChange={(event): void => changeName(event)}
                        onBlur={() => {}}
                    />
                </div>
                <div className="AddEditUserModal-Textfield">
                    <Textfield
                        label="Email"
                        error={emailExists == null ? false : emailExists}
                        helperText={emailErrorMessage}
                        value={selectedUser !== undefined ? selectedUser.emailAddress : ''}
                        // disabled={isEditForm}
                        onBlur={value => {
                            if (value) {
                                changeEmail(value);
                            }
                        }}
                    />
                </div>
            </div>
            <div className="AddEditUserModal-Upper-TextField-Container">
                <div className="AddEditUserModal-Textfield">
                    <MultiSelectDropdownV2
                        dropdownOptions={regions}
                        label="Region"
                        onChange={(value: OptionType): void => {
                            onRegionChange(value);
                        }}
                        key={`my_unique_select_key__${JSON.stringify(selectedRegions)}`}
                        value={selectedRegions}
                    />
                </div>
                <div className="AddEditUserModal-Textfield">
                    <MultiSelectDropdownV2
                        dropdownOptions={availableDistricts}
                        label="Districts"
                        onChange={(value: OptionType): void => {
                            onDistrictChange(value);
                        }}
                        key={`my_unique_select_key__${JSON.stringify(selectedDistricts)}`}
                        value={selectedDistricts}
                    />
                </div>
            </div>
            <div className="AddEditUserModal-Down-TextField-Container">
                <SearchableDropdown
                    dropdownOptions={options}
                    id="role"
                    label="Role"
                    onSelect={(eventKey: string | null) => {
                        changeRole(eventKey);
                    }}
                    value={getRoleName()}
                />
            </div>
            <div className="AddEditUserModal-HasAccess-Container">
                <div className="AddEditUserModal-HasAccess-Title">Has access to SBS?</div>
                <div className="AddEditUserModal-HasAccess-Radio-Container">
                    <div className="AddEditUserModal-Radio">
                        <input
                            className="AddEditUserModal-Radio-Input"
                            type="radio"
                            value="true"
                            checked={selectedStatus}
                            onChange={(event): void => changeStatus(event)}
                        />
                        Yes
                    </div>
                    <div>
                        <input
                            className="AddEditUserModal-Radio-Input"
                            type="radio"
                            value="false"
                            checked={!selectedStatus}
                            onChange={(event): void => changeStatus(event)}
                        />
                        No
                    </div>
                </div>
            </div>
            <div>
                {userAuditHistory && userAuditHistory.length > 0 && (
                    <div>
                        <div className="DriverCompany-Header-Item justify-content-start">User Audit History</div>
                        <div className="Row">
                            <div className="DriverCompany-Header-Item justify-content-start">Audit Date</div>
                            <div className="DriverCompany-Header-Item justify-content-start">Audit User</div>
                            <div className="DriverCompany-Header-Item justify-content-start">Name</div>
                            <div className="DriverCompany-Header-Item justify-content-start">Email Address</div>
                            <div className="DriverCompany-Header-Item justify-content-start">HasAccess</div>
                            <div className="DriverCompany-Header-Item justify-content-start">Role </div>
                        </div>
                    </div>
                )}

                <div>
                    {userAuditHistory &&
                        userAuditHistory.map((userAudit: UserAudits, index): React.ReactElement | undefined => {
                            if (
                                userAudit !== null &&
                                (userAudit.nameBefore !== userAudit.nameAfter ||
                                    userAudit.emailAddressBefore !== userAudit.emailAddressAfter ||
                                    userAudit.isActiveBefore !== userAudit.isActiveAfter ||
                                    userAudit.roleIdBefore !== userAudit.roleIdAfter)
                            ) {
                                return (
                                    <div className="DriverCompany-Info-Row justify-content-start" key={`user${index}`}>
                                        <div className="DriverCompany-Info-Row justify-content-start">
                                            {moment(userAudit.auditDate!).format('YYYY-MM-DD')}
                                        </div>
                                        <div className="DriverCompany-Info-Row justify-content-start">
                                            {userAudit.auditUserName}
                                        </div>
                                        {userAudit.nameBefore !== userAudit.nameAfter && (
                                            <div className="DriverCompany-Info-Row justify-content-start">
                                                {userAudit.nameBefore}
                                            </div>
                                        )}
                                        {userAudit.nameBefore === userAudit.nameAfter && (
                                            <div className="DriverCompany-Info-Row justify-content-start">-</div>
                                        )}
                                        {userAudit.emailAddressBefore !== userAudit.emailAddressAfter && (
                                            <div className="DriverCompany-Info-Row justify-content-start">
                                                {userAudit.emailAddressBefore}
                                            </div>
                                        )}
                                        {userAudit.emailAddressBefore === userAudit.emailAddressAfter && (
                                            <div className="DriverCompany-Info-Row justify-content-start">-</div>
                                        )}
                                        {userAudit.isActiveBefore !== userAudit.isActiveAfter && (
                                            <div className="DriverCompany-Info-Row justify-content-start">
                                                {userAudit.isActiveBefore ? 'Active' : 'Inactive'}
                                            </div>
                                        )}
                                        {userAudit.isActiveBefore === userAudit.isActiveAfter && (
                                            <div className="DriverCompany-Info-Row justify-content-start">-</div>
                                        )}
                                        {userAudit.roleIdBefore !== userAudit.roleIdAfter && (
                                            <div className="DriverCompany-Info-Row justify-content-start">
                                                {getAuditRoleName(userAudit.roleIdBefore!)}
                                            </div>
                                        )}
                                        {userAudit.roleIdBefore === userAudit.roleIdAfter && (
                                            <div className="DriverCompany-Info-Row justify-content-start">-</div>
                                        )}
                                    </div>
                                );
                            }

                            return undefined;
                        })}
                </div>
            </div>

            <Modal.Footer className="AddEditUserModal-Footer">
                <CustomButton title="Cancel" isBordered onClick={onCancel}></CustomButton>
                <CustomButton title="Save" isDisabled={setSaveButtonStatus()} onClick={onSave}></CustomButton>
            </Modal.Footer>
        </Modal>
    );
};

export default AddEditUserModal;

